import React from "react";
import { Container } from "react-bootstrap";

const OurContactUs = () => {
  return (
    <>
      <div className="bg_contact min_vh_contact ">
        <div className=" d-flex justify-content-center align-items-center min_vh_contact">
          <h1 className=" ff_Poppins text-white fw-bold lh_151 fs_96">
            Contact Us
          </h1>
        </div>
      </div>
    </>
  );
};

export default OurContactUs;
